import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CheckoutFacade } from '@checkout/data-access';
import {
  CheckoutRoutes,
  CmsPersonalDetailsPage,
  PersonalDetailsFormValue,
} from '@checkout/util-models';
import { CmsContainer } from '@domgen/dgx-fe-cms';
import { Observable, combineLatest } from 'rxjs';
import { formatPersonalDetailsFormValueToCustomerDetails } from '../../utils/personal-details-form/personal-details-form.utils';

export interface ViewModel {
  cmsData: CmsPersonalDetailsPage;
}

@Injectable()
export class PersonalDetailsComponentService {
  readonly vm$: Observable<ViewModel> = combineLatest({
    cmsData: this.cmsContainer.content$,
  });

  constructor(
    private readonly checkoutFacade: CheckoutFacade,
    private readonly cmsContainer: CmsContainer<CmsPersonalDetailsPage>,
    private readonly router: Router
  ) {}

  onFormSubmit(formValue: PersonalDetailsFormValue): void {
    const customerDetails =
      formatPersonalDetailsFormValueToCustomerDetails(formValue);

    if (!customerDetails) {
      return;
    }

    this.checkoutFacade.upsertCustomerDetails(customerDetails);
    this.continueToNextStep();
  }

  private continueToNextStep(): void {
    this.router.navigateByUrl(CheckoutRoutes.MarketingPreferences);
  }
}
